import { NfseAmbienteNacional, RegimeEspecialTributacao } from './filial';

/**
 * Situação da NFS-e / DPS no fluxo de emissão (Padrão Nacional).
 * Espelha com.jkawflex.def.NfseSituacao — serializado como STRING pelo backend.
 */
export enum NfseSituacao {
    EM_DIGITACAO = 'EM_DIGITACAO',
    PROCESSANDO = 'PROCESSANDO',
    AUTORIZADA = 'AUTORIZADA',
    REJEITADA = 'REJEITADA',
    CANCELADA = 'CANCELADA'
}

/** Rótulos de exibição da situação da NFS-e. */
export const NFSE_SITUACAO_DESCRICAO: { [key: string]: string } = {
    EM_DIGITACAO: 'Em digitação',
    PROCESSANDO: 'Processando/Enviada',
    AUTORIZADA: 'Autorizada',
    REJEITADA: 'Rejeitada',
    CANCELADA: 'Cancelada'
};

/**
 * Dados da NFS-e (Padrão Nacional) embutidos no cabeçalho do lançamento.
 * Espelha com.jkawflex.domain.empresa.FatDoctoCNfse (@Embeddable em fat_docto_c) —
 * o lançamento de serviço continua sendo um FatDoctoC/FatDoctoI comum, só muda o
 * modelo da série (99) e este bloco de dados fiscais do ISSQN.
 */
export interface FatDoctoCNfse {
    /** Chave de acesso da NFS-e — 50 posições (a de NF-e tem 44). */
    nfseChaveacesso: string;
    nfseIdDps: string;
    nfseNdps: number;
    nfseSerieDps: string;
    nfseCompetencia: Date;
    nfseSituacao: NfseSituacao;
    nfseAmbiente: NfseAmbienteNacional;
    nfseProtocolo: string;
    nfseNsu: string;
    nfseCodVerificacao: string;
    nfseDataProcessamento: any;
    nfseMotivo: string;
    nfseMunicipioIncidencia: string;
    nfseRegEspTrib: RegimeEspecialTributacao;
    nfseIssRetido: boolean;
    nfseBaseCalculo: number;
    nfseAliquotaIss: number;
    nfseValorLiquido: number;
    nfseValorDeducoes: number;
    nfseDescIncond: number;
    nfseDescCond: number;
    nfseValorIr: number;
    nfseValorCsll: number;
    nfseXmlDps: string;
    nfseXml: string;
}
